angular.module('picmonicng').factory('ReviewsConfig', [
  '$resource',
  function ReviewsConfigFactory($resource) {
    return {
      negative_categories: [
        {
          name: 'Information Coverage',
          prefix: 'info_coverage_',
          checkboxes: [
            { name: 'Too Much', column: 'too_much' },
            { name: 'Not Enough', column: 'not_enough' },
            { name: 'Typos', column: 'typos' },
            { name: 'Wrong Facts', column: 'wrong_facts' },
          ],
        },
        {
          name: 'Storyline',
          prefix: 'storyline_',
          checkboxes: [
            { name: 'Not Memorable', column: 'not_memorable' },
            { name: 'Hard To Follow', column: 'hard_to_follow' },
            { name: 'Bad Mnemonic', column: 'bad_mnemonic' },
            { name: 'Bad Characters', column: 'bad_characters' },
          ],
        },
        {
          name: 'Audio',
          prefix: 'audio_',
          checkboxes: [
            { name: 'Too Long', column: 'too_long' },
            { name: 'Too Short', column: 'too_short' },
            { name: 'Poor Pronunciation', column: 'poor_pronunciation' },
            { name: 'Voice', column: 'voice' },
          ],
        },
        {
          name: 'Art',
          prefix: 'art_',
          checkboxes: [
            { name: 'Messy', column: 'messy' },
            { name: 'Bland', column: 'bland' },
            { name: 'Overwhelming', column: 'overwhelming' },
            {
              name: 'Character Inconsistency',
              column: 'character_inconsistency',
            },
          ],
        },
      ],
      positive_categories: [
        {
          name: 'Information Coverage',
          prefix: 'info_coverage_',
          checkboxes: [
            { name: 'Valuable', column: 'valuable_information' },
            { name: 'Accurate', column: 'accurate_information' },
            { name: 'Right Amount', column: 'right_amount_of_information' },
            { name: 'Easy To Learn', column: 'easy_to_learn' },
          ],
        },
        {
          name: 'Storyline',
          prefix: 'storyline_',
          checkboxes: [
            { name: 'Very Memorable', column: 'very_memorable' },
            { name: 'Cohesive Story', column: 'cohesive_story' },
            { name: 'Original Story', column: 'original_story' },
            { name: 'Good Characters', column: 'good_characters' },
          ],
        },
        {
          name: 'Audio',
          prefix: 'audio_',
          checkboxes: [
            { name: 'Good Length', column: 'good_length' },
            { name: 'Enjoyable Voice', column: 'enjoyable_voice' },
            { name: 'Entertaining', column: 'entertaining' },
            { name: 'Teaches Well', column: 'teaches_well' },
          ],
        },
        {
          name: 'Art',
          prefix: 'art_',
          checkboxes: [
            { name: 'Good Style', column: 'good_style' },
            { name: 'Anatomically Correct', column: 'anatomically_correct' },
            { name: 'Memorable', column: 'memorable' },
            { name: 'Topic Character', column: 'recognizable_topic_character' },
          ],
        },
      ],
      reporting_categories: [
        {
          name: 'Harmful Written or Visual Content',
          prefix: 'report_',
          checkboxes: [
            { name: 'Profanity', column: 'profane' },
            { name: 'Racism', column: 'racist' },
            { name: 'Sexism', column: 'sexist' },
            { name: 'Religious Insensitivity', column: 'religious' },
            { name: 'Sexually Explicit', column: 'explicit' },
            { name: 'Excessive Violence', column: 'violent' },
            { name: 'Illegal Activity', column: 'illegal' },
          ],
        },
      ],
    };
  },
]);
